<script setup lang="ts">
import useSwr from "@/core/composables/swr/useSwr";
import {laboratoryApi} from "@/container";
import BaseFlexSpinner from "@/core/components/base/spinner/BaseFlexSpinner.vue";
import {computed, ref} from "vue";
import AttachmentGrid from "@/attachment/components/AttachmentGrid.vue";
import {cacheKey} from "@/lib/cache";

const props = defineProps<{
    laboratoryId: string;
}>();

const page = ref<number>(1);

const {data, isLoading} = useSwr(
    computed(() => cacheKey(`laboratories/${props.laboratoryId}/attachments?page=${page.value}`)),
    () => laboratoryApi().attachments(Number(props.laboratoryId), {page: page.value}),
    {
        revalidateOnFocus: false
    }
);
</script>

<template>
  <div v-if="isLoading">
    <BaseFlexSpinner />
  </div>
  <div v-else-if="data?.data?.length">
    <div class="p-4">
      <attachment-grid :attachments="data.data" />
      <div class="flex flex-1 justify-center items-center">
        <v-pagination
          v-model="page"
          :length="data?.meta?.last_page ?? 1"
          :total-visible="7"
          circle
        />
      </div>
    </div>
  </div>
  <div v-else>
    <div class="flex flex-col items-center justify-center h-full pt-4">
      <p>Aucune ressource associé à ce laboratoire pour le moment</p>
    </div>
  </div>
</template>
